export const cleanName = (name: string): string => {
    return name.replaceAll(' ', '').toLowerCase();
}